import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  disabled: {
    color: theme.palette.icon.disabled,
  },
}));

export default useStyles;
